export const endpoints = {
    login: "/account/login",
    userInfo:"/account/userInfo",
    user: "/user",
    role: "/role",
    product: "/product",
    category: "/category",
    unitOfMeasurement: "/unitOfMeasurement",
    movement: "/movement",
    orderPad: "/orderPad",
    orderPadItems: "/orderPadItem"
}